import React, { MutableRefObject, SetStateAction } from "react";
import { SelectFieldOption_Values } from "../../../Definitions";
import { DayComponent, FeedCurve, MaintainFeedCurve } from "../../../Services";
import { clone, cloneDeep, keyBy, merge, partition, union } from "lodash";
import { Row } from "@tanstack/react-table";
import { FeedCurveTableData, valueIsNumberValue, valueIsSelectFieldOptionsValue } from "./feedCurveTableUtils";

//TODO CTO REFACTOR 
export function updateFeedCurveTable({ rowId, columnId, value, row, feedCurve, dirtRef, setFeedCurve, data, createdDayComponentsIdRef, createdMilestoneIdRef, skipAutoResetPageIndex, energyMode }: { rowId: number; columnId: string; value: string | number | boolean | SelectFieldOption_Values | undefined; row: Row<FeedCurveTableData>; feedCurve: FeedCurve; dirtRef: React.MutableRefObject<{[key: number]: MaintainFeedCurve} & {baseFeedCurve: MaintainFeedCurve}>; setFeedCurve: (value: SetStateAction<FeedCurve>) => void; data: Map<number, FeedCurveTableData>; createdDayComponentsIdRef: MutableRefObject<number>; createdMilestoneIdRef: MutableRefObject<number>; skipAutoResetPageIndex: () => void; energyMode:boolean }) {
  skipAutoResetPageIndex();
  const oldRow = data.get(rowId);
  if (!feedCurve.milestones) {
    return;
  }
  if (columnId === "totalAmount" && valueIsNumberValue(value, columnId) && oldRow) { 
    const feedCurveMilestoneId = oldRow.milestoneId;
    const deviation = value/oldRow[columnId]
    if (feedCurve.milestones[oldRow.milestoneArrayIndex] && feedCurve.milestones[oldRow.milestoneArrayIndex].feedDays) {
      const currentDay = feedCurve.milestones[oldRow.milestoneArrayIndex].feedDays[oldRow.dayIndex]
      const changes = (feedCurve.components ?? []).reduce((accumulator, currentValue) => {
        const oldAmount = oldRow[currentValue.componentId];
        if (oldAmount && currentDay) {
          const currentComponent = currentDay.dayComponents.find((component) => (component.componentId === currentValue.componentId));
          if (currentComponent) {
            currentComponent.amount = Math.round(currentComponent.amount * deviation);
            accumulator.push(currentComponent)
          }
        }
        return accumulator
      },[] as DayComponent[]);

      if (dirtRef.current[feedCurveMilestoneId] === undefined) {
        dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId};
      }

      if (dirtRef.current[feedCurveMilestoneId].updates === undefined) {
        dirtRef.current[feedCurveMilestoneId].updates={};
      }
      if (dirtRef.current[feedCurveMilestoneId].creates === undefined) {
        dirtRef.current[feedCurveMilestoneId].creates={};
      }
      const [createValueUpdates, existingValueUpdate] = partition(changes, (change) => (change.dayComponentId < 0))
      dirtRef.current[feedCurveMilestoneId].updates.dayComponents = Object.values(merge({}, keyBy(dirtRef.current[feedCurveMilestoneId].updates?.dayComponents, "dayComponentId"), keyBy(existingValueUpdate.map(({amount, dayComponentId}) => ({dayComponentId, baseInfo: {amount}})), "dayComponentId")));
      if (dirtRef.current[feedCurveMilestoneId].creates.milestones && createValueUpdates.length > 0) {
        const dirtyMilestone = dirtRef.current[feedCurveMilestoneId].creates.milestones.find((milestone) => (milestone.temporaryId === oldRow.milestoneId));
        if (dirtyMilestone && dirtyMilestone.feedDays) {
          const dirtyDay = dirtyMilestone.feedDays.find((feedDay) => (feedDay.temporaryId === oldRow.id));
          if (dirtyDay && dirtyDay.dayComponents) {
            dirtyDay.dayComponents = createValueUpdates.map(({amount, componentId, dayComponentId}) => ({amount, component_id: componentId, temporaryId: dayComponentId}))
          }
        } 
      }
      setFeedCurve({...feedCurve});
      return
      }
    }
  if (columnId === "milestone" && valueIsSelectFieldOptionsValue(value, columnId) && oldRow) {
    const feedCurveMilestoneId = oldRow.milestoneId;
    if (oldRow.milestone && (Number(oldRow.milestone?.id)) > 0) {
      if (oldRow.milestoneId > 0) {
        if (dirtRef.current[feedCurveMilestoneId] === undefined) {
          dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId};
        }
        if (dirtRef.current[feedCurveMilestoneId].updates === undefined) {
          dirtRef.current[feedCurveMilestoneId].updates = {} 
        }
        dirtRef.current[feedCurveMilestoneId].updates.milestones = Object.values(merge({}, keyBy(dirtRef.current[feedCurveMilestoneId].updates.milestones, "feedCurveMilestoneId"), keyBy([{feedCurveMilestoneId: row.original.milestoneId, baseInfo: {fk_milestones: value.id}}], "dayComponentId")))
      } else {
        if (dirtRef.current[feedCurveMilestoneId] === undefined) {
          dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId};
        }
        if (dirtRef.current[feedCurveMilestoneId].creates === undefined) {
          dirtRef.current[feedCurveMilestoneId].creates = {} 
        }
        if (dirtRef.current[feedCurveMilestoneId].creates.milestones) {
          const newMilestone = dirtRef.current[feedCurveMilestoneId].creates.milestones.find((milestone) => milestone.temporaryId === oldRow.milestoneId);
          if (newMilestone) {
            newMilestone.milestone_id = Number(value.id ?? -1);
          }
        }
      }
      
      feedCurve.milestones[oldRow.milestoneArrayIndex].milestoneId = Number(value.id ?? -1);
      feedCurve.milestones[oldRow.milestoneArrayIndex].name = value.label;
      setFeedCurve(cloneDeep(feedCurve));
      return
    }
     // TODO HERE YOU NEED TO THING
    const [affectedMilestones, remainingMilestones] = partition(feedCurve.milestones, (milestone) => (milestone.milestoneIndex > oldRow.milestoneIndex ));
    const changeAffectedMilestones = affectedMilestones.map((milestone) => ({...milestone, milestoneIndex: milestone.milestoneIndex+1}));
    const feedCurveMilestone = remainingMilestones.find((milestone) => milestone.feedCurveMilestoneId === oldRow.milestoneId);
    const [remainingDays, daysToCreate] = partition(feedCurveMilestone?.feedDays, (feedDay) => ((feedCurveMilestone?.milestoneIndex === 1 ? +feedDay.day : feedDay.day + oldRow.milestoneFirstDay) < oldRow.day));
    if (feedCurveMilestone !== undefined) {
      feedCurveMilestone.feedDays = remainingDays
    }
    feedCurve.milestones = [...remainingMilestones, ...changeAffectedMilestones];

    if (oldRow.milestone && (Number(oldRow.milestone?.id)) <0) {
      feedCurve.milestones.splice(oldRow.milestoneArrayIndex,1);
    }
    const tempFeedCurveMilestoneId = -createdMilestoneIdRef.current
    const newMilestone = {milestoneId: Number(value.id ?? -1), milestoneIndex: oldRow.milestoneIndex+1, name: value.label, feedCurveMilestoneId: tempFeedCurveMilestoneId, feedDays: daysToCreate.map((feedDay) => {createdDayComponentsIdRef.current += 1; return {day: feedDay.day-Math.min(...daysToCreate.map((day) => (day.day))), dayId: -(createdDayComponentsIdRef.current-1), dayComponents: feedDay.dayComponents.map((dayComponent) => ({...dayComponent, dayComponentId: -1 }))};})}
    createdMilestoneIdRef.current += 1;
    feedCurve.milestones.push(newMilestone)
    setFeedCurve(cloneDeep(feedCurve))
    if (oldRow.milestoneId < 0 ){
      return;
    }
    if (dirtRef.current[tempFeedCurveMilestoneId] === undefined) {
      dirtRef.current[tempFeedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId};
    }
    if (dirtRef.current[tempFeedCurveMilestoneId].creates === undefined) {
      dirtRef.current[tempFeedCurveMilestoneId].creates = {};
    }
    if (dirtRef.current[tempFeedCurveMilestoneId].creates.milestones === undefined) {
      dirtRef.current[tempFeedCurveMilestoneId].creates.milestones = [];
    }
    if (dirtRef.current[feedCurveMilestoneId] === undefined) {
      dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId};
    }
    if (dirtRef.current[feedCurveMilestoneId].deletes === undefined) {
      dirtRef.current[feedCurveMilestoneId].deletes = {};
    }
    if (dirtRef.current[feedCurveMilestoneId].deletes.feedDays === undefined) {
      dirtRef.current[feedCurveMilestoneId].deletes.feedDays =[];
    }

    const [daysToDelete,daysToRemoveFromCreate] = partition(daysToCreate.map((day) => day.dayId), (dayId) => dayId > 0);
    if (daysToRemoveFromCreate.length) {
      const dirtRefMilestoneToChange =  dirtRef.current[feedCurveMilestoneId].creates?.milestones?.find((milestone) => (milestone.temporaryId === oldRow.milestoneId));
      if (dirtRefMilestoneToChange) {
        dirtRefMilestoneToChange.feedDays = (dirtRefMilestoneToChange.feedDays ?? []).filter((day) => { return !daysToRemoveFromCreate.includes(day.temporaryId)}); 
      };
    }     

    dirtRef.current[feedCurveMilestoneId].deletes.dayComponents = union(dirtRef.current[feedCurveMilestoneId].deletes.dayComponents, daysToDelete);

    dirtRef.current[tempFeedCurveMilestoneId].creates.milestones = [...dirtRef.current[tempFeedCurveMilestoneId].creates.milestones, {temporaryId: newMilestone.feedCurveMilestoneId, milestone_id: newMilestone.milestoneId, milestone_index: newMilestone.milestoneIndex, feedDays: newMilestone.feedDays.map(({day, dayComponents, dayId}) => ({temporaryId: dayId, day, dayComponents: dayComponents.map(({componentId, amount, dayComponentId}) => ({component_id: componentId, amount, temporaryId: dayComponentId}))}))}]
    return
  }
  if (columnId === "day" && valueIsNumberValue(value, columnId) && oldRow) {
    const feedCurveMilestoneId = oldRow.milestoneId;
    const feedCurveMilestone = feedCurve.milestones[oldRow.milestoneArrayIndex];
    if (feedCurveMilestone) {
      const day = feedCurveMilestone.feedDays[oldRow.dayIndex]
        day.day = feedCurveMilestone.milestoneIndex === 1 ? +value : value - oldRow.milestoneFirstDay;
        setFeedCurve(cloneDeep(feedCurve));
        if (day.dayId < 0) {
          if (dirtRef.current[feedCurveMilestoneId]?.creates && dirtRef.current[feedCurveMilestoneId]?.creates.milestones) {
            const dirtyMilestone = dirtRef.current[feedCurveMilestoneId].creates.milestones.find((milestone) => (milestone.temporaryId === feedCurveMilestone.feedCurveMilestoneId));
            if (dirtyMilestone && dirtyMilestone.feedDays) {
              const dirtyDay = dirtyMilestone.feedDays.find((feedDay) => (feedDay.temporaryId === day.dayId));
              if (dirtyDay) {
                dirtyDay.day = value - oldRow.milestoneFirstDay;
              }
            }
          }
        } else { // create ref if missing
          if (dirtRef.current[feedCurveMilestoneId] === undefined) {
            dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId}
          } 
          if (dirtRef.current[feedCurveMilestoneId].updates === undefined) {
            dirtRef.current[feedCurveMilestoneId].updates = {};
          }
          if (dirtRef.current[feedCurveMilestoneId].updates.feedDays === undefined) {
            dirtRef.current[feedCurveMilestoneId].updates.feedDays = [];
          }
          dirtRef.current[feedCurveMilestoneId].updates.feedDays = Object.values(merge({}, keyBy(dirtRef.current[feedCurveMilestoneId].updates.feedDays, "dayId"), keyBy([{dayId: day.dayId, baseInfo: {day: day.day}}],"dayId")))
        }
        return
      }
    }
  if (oldRow && valueIsNumberValue(value, columnId)) {
    const feedCurveMilestoneId = oldRow.milestoneId;
    const feedCurveMilestone = feedCurve.milestones[oldRow.milestoneArrayIndex]
    if (!feedCurveMilestone) {return}
    
    const day = feedCurveMilestone.feedDays[oldRow.dayIndex]
    if (!day) { return } 
    
    const dayComponent = day.dayComponents.find((dayComponent) => (dayComponent.componentId === +columnId));
    if (dayComponent && feedCurve.components) {
      const energy = feedCurve.components.find((component) => component.componentId === dayComponent.componentId)?.energy
      let amount = energyMode ? (value*1000) / (energy ?? 1) : value * 1000;
      dayComponent.amount = Math.round(amount);
      setFeedCurve(clone(feedCurve));
      if (dayComponent.dayComponentId<0) {
        if (dirtRef.current[feedCurveMilestoneId].creates && dirtRef.current[feedCurveMilestoneId].creates.milestones) {
          const dirtyMilestone = dirtRef.current[feedCurveMilestoneId].creates.milestones.find((milestone) => milestone.temporaryId === feedCurveMilestone.feedCurveMilestoneId);
          if (dirtyMilestone && dirtyMilestone.feedDays) {
            const dirtyDay = dirtyMilestone.feedDays.find((feedDay) => (feedDay.temporaryId === day.dayId));
            if (dirtyDay) {
              if (dirtyDay.dayComponents) {
                const dirtyDayComponent = dirtyDay.dayComponents.find((dirtyDayComponent) => dirtyDayComponent.temporaryId === dayComponent.dayComponentId);
                if (dirtyDayComponent) {
                  dirtyDayComponent.amount = dayComponent.amount;
                }
              } else {
                dirtyDay.dayComponents = [{temporaryId: dayComponent.dayComponentId, amount: dayComponent.amount, component_id: dayComponent.componentId}]
              }
            }
          }
        }
         
        return 
      }
      // create ref if missing
      if (dirtRef.current[feedCurveMilestoneId] === undefined) {
        dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId}
      } 
      if (dirtRef.current[feedCurveMilestoneId].updates === undefined) {
        dirtRef.current[feedCurveMilestoneId].updates = {};
      }
      if (dirtRef.current[feedCurveMilestoneId].updates.dayComponents === undefined) {
        dirtRef.current[feedCurveMilestoneId].updates.dayComponents = []
      }
      dirtRef.current[feedCurveMilestoneId].updates.dayComponents = Object.values(merge({}, keyBy(dirtRef.current[feedCurveMilestoneId].updates.dayComponents, "dayComponentId"), keyBy([{dayComponentId: dayComponent.dayComponentId, baseInfo: {amount: dayComponent.amount}}], "dayComponentId")));
      
      return;

    }
    const energy = feedCurve.components?.find((component) => component.componentId === +columnId)?.energy
    let amount = energyMode ? (value*1000) / (energy ?? 1) : value * 1000;
    const newDayComponent = {dayComponentId: -createdDayComponentsIdRef.current, amount: Math.round(amount), componentId: +columnId};

    day.dayComponents.push(newDayComponent);
    setFeedCurve(clone(feedCurve));

    if (dirtRef.current[feedCurveMilestoneId] === undefined) {
      dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId}
    }
    if (dirtRef.current[feedCurveMilestoneId].creates === undefined) {
      dirtRef.current[feedCurveMilestoneId].creates={}
    }
    const newDirtyDayComponent = {amount: newDayComponent.amount, component_id: newDayComponent.componentId, temporaryId: newDayComponent.dayComponentId};
    const newDirtyFeedDay = {day: day.day, dayId: day.dayId<0 ? undefined: day.dayId, temporaryId: day.dayId, dayComponents: [newDirtyDayComponent]}
    const newDirtyMilestone = { feedCurveMilestoneId: feedCurveMilestone.feedCurveMilestoneId < 0 ? undefined : feedCurveMilestone.feedCurveMilestoneId, milestone_id: feedCurveMilestone.milestoneId, milestone_index: feedCurveMilestone.milestoneIndex, temporaryId: feedCurveMilestone.feedCurveMilestoneId,
          feedDays: [newDirtyFeedDay]
        }
    if (dirtRef.current[feedCurveMilestoneId].creates.milestones) {
      const dirtyMilestone = dirtRef.current[feedCurveMilestoneId].creates.milestones.find((milestone) => (milestone.temporaryId === feedCurveMilestone.feedCurveMilestoneId));
      if (dirtyMilestone) {
        const dirtyDay = dirtyMilestone.feedDays?.find((feedDay) => feedDay.temporaryId === day.dayId);
        if (dirtyDay) {
          const dirtyDayComponent = dirtyDay.dayComponents?.find((dayComponent) => (dayComponent.temporaryId === newDayComponent.dayComponentId));
          if (dirtyDayComponent) {
            dirtyDayComponent.amount = newDirtyDayComponent.amount;
          } else {
            dirtyDay.dayComponents ? dirtyDay.dayComponents.push(newDirtyDayComponent) : dirtyDay.dayComponents = [newDirtyDayComponent];
          }
        } else {
          dirtyMilestone.feedDays ? dirtyMilestone.feedDays.push(newDirtyFeedDay) : dirtyMilestone.feedDays = [newDirtyFeedDay];
        }
      } else {
        dirtRef.current[feedCurveMilestoneId].creates.milestones.push(newDirtyMilestone)
      }

    } else {
      dirtRef.current[feedCurveMilestoneId].creates.milestones = [newDirtyMilestone]
    }
    createdDayComponentsIdRef.current += 1;
    
    // setFeedCurve(cloneDeep(feedCurve));
    return
  }
  
  if (oldRow && (value === undefined || value === "" || value === "0")) {
    const feedCurveMilestoneId = oldRow.milestoneId;
    const feedCurveMilestone = feedCurve.milestones[oldRow.milestoneArrayIndex]
    if (feedCurveMilestone) {
      const day = feedCurveMilestone.feedDays[oldRow.dayIndex]
      if (day) {
        const dayToDeleteIndex = day.dayComponents.findIndex((dayComponents) => (dayComponents.componentId===+columnId));
        // ref create
        if (dirtRef.current[feedCurveMilestoneId] === undefined) {
          dirtRef.current[feedCurveMilestoneId] = {feedCurveId: feedCurve.feedCurveId}
        } 
        if (dirtRef.current[feedCurveMilestoneId].deletes === undefined) {
          dirtRef.current[feedCurveMilestoneId].deletes = {};
        }
        if (dirtRef.current[feedCurveMilestoneId].deletes.dayComponents === undefined) {
          dirtRef.current[feedCurveMilestoneId].deletes.dayComponents = [];
        }
        if (day.dayComponents[dayToDeleteIndex].dayComponentId < 0) {
          const milestoneArrayIndex = dirtRef.current[feedCurveMilestoneId].creates?.milestones?.findIndex((milestone) => milestone.temporaryId === oldRow.milestoneId);
          if (milestoneArrayIndex && dirtRef.current[feedCurveMilestoneId].creates?.milestones && dirtRef.current[feedCurveMilestoneId].creates.milestones[milestoneArrayIndex].feedDays) {
            dirtRef.current[feedCurveMilestoneId].creates.milestones[milestoneArrayIndex].feedDays = dirtRef.current[feedCurveMilestoneId].creates.milestones[milestoneArrayIndex].feedDays.filter((feedDay) => (feedDay.temporaryId !== day.dayComponents[dayToDeleteIndex].dayComponentId))
          }
        } else {
          dirtRef.current[feedCurveMilestoneId].deletes.dayComponents.push(day.dayComponents[dayToDeleteIndex].dayComponentId);
        }
        day.dayComponents.splice(dayToDeleteIndex, 1);
      }
    }
    setFeedCurve(cloneDeep(feedCurve));
    return
  }
}
